export const PHRASE_TRIGGER_REPORT_PREFIX = "triggerReport";
